<style scoped>
.payroll_header_row {
	background: white;
}

.edit_payroll_header_row {
	margin-left: -10px;
	margin-top: -10px;
	margin-bottom: -10px;
	padding-left: 10px;
	padding-top: 10px;
	padding-bottom: 10px;
}

.edit_payroll_header_row:hover {
	background: #DDDDDD;
}

.new_employment_info {
	background: #EEEEEE;
	margin-bottom: 5px;
    padding: 5px;
}

.new_employment_info:hover {
	background: #DDDDDD;
}

.new_tax_info {
	background: #EEEEEE;
	margin-top: 15px;
	margin-bottom: 5px;
    padding: 5px;
}

.new_tax_info:hover {
	background: #DDDDDD;
}

.new_tax_event {
	background: #EEEEEE;
	margin-top: 15px;
	margin-bottom: 5px;
    padding: 5px;
}

.new_tax_event:hover {
	background: #DDDDDD;
}

</style>

<template>
	<v-expansion-panel class="payroll_header_row">
		<v-expansion-panel-header class="blue--text">
			<div class="edit_payroll_header_row" @click.stop="edit_payroll_header">
				<span>Payroll id {{ payroll_header.payroll_number }}</span>
				<span>, {{ rectype }}</span>
				<span> from {{ start_date }}</span>
				<span v-if="payroll_header.end_date"> until {{ end_date }}</span>
			</div>
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<v-alert type="error" v-if="errormsg != ''">
				{{errormsg}}
			</v-alert>

			<div class="new_employment_info" @click.stop="new_employment_info" v-if="payroll_header.rectype == 0 || payroll_header.rectype == 2 || payroll_header.rectype == 3">
				<b>Add new employment info</b>
			</div>
			<v-skeleton-loader
				v-if="loading_employment_info"
				type="list-item-two-line"
			/>
			<v-employment-info-row
				v-for="empinfo in empinfos"
				popup_editors="popup_editors"
				:key="empinfo.id"
				:employment_info="empinfo"
			/>

			<div class="new_tax_info" @click.stop="new_tax_info" v-if="payroll_header.rectype == 0 || payroll_header.rectype == 1 || payroll_header.rectype == 2 || payroll_header.rectype == 3">
				<b>Add new tax info</b>
			</div>
			<v-skeleton-loader
				v-if="loading_tax_empinfo"
				type="list-item-two-line"
			/>
			<v-tax-empinfo-row
				v-for="taxinfo in taxinfos"
				popup_editors="popup_editors"
				:key="taxinfo.id"
				:tax_empinfo="taxinfo"
			/>

			<div class="new_tax_event" @click.stop="new_tax_event" v-if="payroll_header.rectype == 0 || payroll_header.rectype == 1 || payroll_header.rectype == 2">
				<b>Add new tax event</b>
			</div>
			<v-skeleton-loader
				v-if="loading_tax_events"
				type="list-item-two-line"
			/>
			<v-tax-event-row
				v-for="taxevent in taxevents"
				popup_editors="popup_editors"
				:key="taxevent.id"
				:tax_event="taxevent"
			/>

			<div v-if="payroll_header.rectype == 3">
				No further details recorded under Voluntary PAYG income stream.
			</div>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
import moment from 'moment';
import employment_info_row from "@/components/addressbook/payroll_header/employment_info_row"
import tax_empinfo_row from "@/components/addressbook/payroll_header/tax_empinfo_row"
import tax_event_row from "@/components/addressbook/payroll_header/tax_event_row"

export default {
	components: {
		'v-employment-info-row': employment_info_row,
		'v-tax-empinfo-row': tax_empinfo_row,
		'v-tax-event-row': tax_event_row,
	},
	props: {
		is_expanded: {
			type: Boolean,
			default: false
		},
		popup_editors: { // when used in the desktop app, we want to popup a new window so Omnis can catch this.
			type: Boolean,
			default: false
		},
		payroll_header: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			errormsg: '',
			loading_employment_info: false,
			loading_tax_empinfo: false,
			loading_tax_events: false,
			is_loaded: false,
			empinfos: [],
			taxinfos: [],
			taxevents: [],
		}
	},
	computed: {
		rectype() {
			if (this.payroll_header.rectype == 0) {
				return 'employee';
			} else if (this.payroll_header.rectype == 1) {
				return 'performing artist';
			} else if (this.payroll_header.rectype == 2) {
				return 'freelancer/non-performing artist';
			} else if (this.payroll_header.rectype == 3) {
				return 'voluntary PAYG';
			} else {
				return 'unknown';
			}
		},
		start_date() {
			return moment(this.payroll_header.start_date).format("DD MMMM YYYY");
		},
		end_date() {
			if (this.payroll_header.end_date) {
				return moment(this.payroll_header.end_date).format("DD MMMM YYYY");
			} else {
				return '';
			}
		},
	},
	mounted() {
		if (this.is_expanded) {
			this.is_loaded = true;
			this.do_load_employment_info();
			this.do_load_tax_empinfo();
			this.do_load_tax_events();
		}
	},
	methods: {
		do_load_employment_info() {
			this.loading_employment_info = true;
			this.errormsg = '';
			this.empinfos = [];
			let self = this;

			// console.log("Loading employment info records");

			// load our employment info records
			let url = this.payroll_header.uri + "/employmentinfo";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let empinfos = json.data;

						empinfos.sort(function(a, b) { return moment(a.start_date) < moment(b.start_date) });

						self.empinfos = empinfos;
					} else {
						self.errormsg = json.reason;
						console.log(self.errormsg);
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_employment_info = false;
				});

		},
		do_load_tax_empinfo() {
			this.loading_tax_empinfo = true;
			this.errormsg = '';
			this.taxinfos = [];
			let self = this;

			// console.log("Loading tax info records");

			// load our tax info records
			let url = this.payroll_header.uri + "/taxinfo";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let taxinfos = json.data;

						taxinfos.sort(function(a, b) { return moment(a.start_date) < moment(b.start_date) });

						self.taxinfos = taxinfos;
					} else {
						self.errormsg = json.reason;
						console.log(self.errormsg);
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_tax_empinfo = false;
				});

		},
		do_load_tax_events() {
			//if (this.payroll_header.rectype != 0) {
			// only applicable to employees
			//	return
			//}
			
			this.loading_tax_events = true;
			this.errormsg = '';
			this.taxevents = [];
			let self = this;

			// console.log("Loading tax event records");

			// load our tax info records
			let url = this.payroll_header.uri + "/taxevents";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						let taxevents = json.data;

						taxevents.sort(function(a, b) { return moment(a.created_on) < moment(b.created_on) });

						self.taxevents = taxevents;
					} else {
						self.errormsg = json.reason;
						console.log(self.errormsg);
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_tax_events = false;
				});

		},
		new_employment_info() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.payroll_header.addressbook_id + '/payroll_header/' + this.payroll_header.id + '/employmentinfo')
			} else {
				// route to new URL once we implement the web interface for this
			}
		},
		new_tax_info() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.payroll_header.addressbook_id + '/payroll_header/' + this.payroll_header.id + '/taxinfo')
			} else {
				// route to new URL once we implement the web interface for this
			}
		},
		new_tax_event() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.payroll_header.addressbook_id + '/payroll_header/' + this.payroll_header.id + '/taxevent')
			} else {
				// route to new URL once we implement the web interface for this
			}
		},
		edit_payroll_header() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.payroll_header.addressbook_id + '/payroll_header/' + this.payroll_header.id)
			} else {
				// route to new URL once we implement the web interface for this
			}
		}
	},
	watch: {
		'is_expanded': function(new_value) {
			// console.log("is_expanded changed");
			if (new_value && !this.is_loaded) {
				this.is_loaded = true;
				this.do_load_employment_info();
				this.do_load_tax_empinfo();
				this.do_load_tax_events();
			}
		}
	}
}
</script>
